export default __webpack_public_path__ + "static/media/play-circle.852e37b3.svg";